import React, { useState, cloneElement } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { translate } from '../../../i18n/I18nProvider';
import ChangeSubscription from '../../simCardsIoT/components/ChangeSubscription';
import can from '../../../utils/can';
import createSubject from '../../../utils/createSubject';

const SubscriptionMenu = ({
  children,
  subscription = {},
  clientId,
  setRefresh
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {cloneElement(children, { onClick: handleClick })}
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <div>
          <ChangeSubscription
            subscription={subscription}
            closeMenu={handleClose}
            setRefresh={setRefresh}
            fromIoT={false}
          >
            <MenuItem
              disabled={
                !can(
                  'change',
                  createSubject('Quote::Subscription', {
                    client_id: Number(clientId)
                  })
                ) || subscription?.status !== 'ACTIVE'
              }
            >
              {translate('SUBSCRIPTIONS.CHANGE_SUBSCRIPTION')}
            </MenuItem>
          </ChangeSubscription>
        </div>
      </Menu>
    </div>
  );
};

export default SubscriptionMenu;
